import { Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { ROUTES } from "@/routes";
import { AdminLoginView } from "@/presentation/auth/AdminLoginView";
import { AdminAuthGuard } from "@/presentation/auth/AdminAuthGuard";
import { AdminLayout } from "@/presentation/layout/AdminLayout";
import { SignalsView } from "@/presentation/signals/SignalsView";
import { TerminalAnalyticsView } from "@/presentation/terminal/TerminalAnalyticsView";
import { TerminalAccountsView } from "@/presentation/provisioning/TerminalAccountsView";
import { NewAccountWizard } from "@/presentation/provisioning/NewAccountWizard";
import { AccountDetailView } from "@/presentation/provisioning/AccountDetailView";
import { MerchantsView } from "@/presentation/merchants/MerchantsView";
import { MerchantDetailView } from "@/presentation/merchants/MerchantDetailView";
import { MerchantTimelineView } from "@/presentation/merchants/MerchantTimelineView";
import { SupportView } from "@/presentation/support/SupportView";
import { ReferralsView } from "@/presentation/marketing/referrals/ReferralsView";
import { ActivationBonusView } from "@/presentation/marketing/activation-bonus/ActivationBonusView";
import { AssistantGapsView } from "@/presentation/assistant/AssistantGapsView";
import { EventsView } from "@/presentation/events/EventsView";
import { EventDetailView } from "@/presentation/events/EventDetailView";
import { TransactionDetailView } from "@/presentation/money/TransactionDetailView";
import { ToolsView } from "@/presentation/tools/ToolsView";
import { JobHistoryView } from "@/presentation/tools/JobHistoryView";
import { CreateMerchantView } from "@/presentation/tools/create-merchant/CreateMerchantView";
import { AdminsView } from "@/presentation/admins/AdminsView";
import { HoopsView } from "@/presentation/hoops/HoopsView";

export default function App() {
  return (
    <>
      <Toaster position="top-right" />
      <Routes>
        <Route path={ROUTES.LOGIN} element={<AdminLoginView />} />
        <Route
          element={
            <AdminAuthGuard>
              <AdminLayout>
                <Routes>
                  <Route path={ROUTES.SIGNALS} element={<SignalsView />} />
                  <Route
                    path={ROUTES.TERMINAL_ANALYTICS}
                    element={<TerminalAnalyticsView />}
                  />
                  <Route
                    path={ROUTES.TERMINAL_ACCOUNTS}
                    element={<TerminalAccountsView />}
                  />
                  <Route
                    path={ROUTES.NEW_ACCOUNT}
                    element={<NewAccountWizard />}
                  />
                  <Route
                    path={ROUTES.ACCOUNT_DETAIL}
                    element={<AccountDetailView />}
                  />
                  <Route
                    path={ROUTES.TERMINAL_ACCOUNT_TRANSACTION_DETAIL}
                    element={<TransactionDetailView />}
                  />
                  <Route path={ROUTES.MERCHANTS} element={<MerchantsView />} />
                  <Route
                    path={ROUTES.MERCHANT_DETAIL}
                    element={<MerchantDetailView />}
                  />
                  <Route
                    path={ROUTES.MERCHANT_TIMELINE}
                    element={<MerchantTimelineView />}
                  />
                  <Route path={ROUTES.SUPPORT} element={<SupportView />} />
                  <Route
                    path="/referrals"
                    element={
                      <Navigate to={ROUTES.MARKETING_REFERRALS} replace />
                    }
                  />
                  <Route
                    path={ROUTES.MARKETING_REFERRALS}
                    element={<ReferralsView />}
                  />
                  <Route
                    path={ROUTES.MARKETING_ACTIVATION_BONUS}
                    element={<ActivationBonusView />}
                  />
                  <Route
                    path={ROUTES.ASSISTANT_GAPS}
                    element={<AssistantGapsView />}
                  />
                  <Route path={ROUTES.EVENTS} element={<EventsView />} />
                  <Route
                    path={ROUTES.EVENT_DETAIL}
                    element={<EventDetailView />}
                  />
                  <Route path={ROUTES.TOOLS} element={<ToolsView />} />
                  <Route
                    path={ROUTES.CREATE_MERCHANT}
                    element={<CreateMerchantView />}
                  />
                  <Route
                    path={ROUTES.TOOL_HISTORY}
                    element={<JobHistoryView />}
                  />
                  <Route
                    path={ROUTES.TRANSACTION_DETAIL}
                    element={<TransactionDetailView />}
                  />
                  <Route path={ROUTES.ADMINS} element={<AdminsView />} />
                  <Route path={ROUTES.PLAY_HOOPS} element={<HoopsView />} />
                  <Route
                    path="*"
                    element={<Navigate to={ROUTES.SIGNALS} replace />}
                  />
                </Routes>
              </AdminLayout>
            </AdminAuthGuard>
          }
          path="/*"
        />
      </Routes>
    </>
  );
}
